import { REGULATIONS } from '../config/regulations.js';

export function matchRegulations(overlaps) {
  const matched = [];

  for (const overlap of overlaps) {
    const layerId = overlap.layerId;
    let regulationKey;

    if (layerId === 'natura2000') {
      regulationKey = 'natura2000';
    } else if (layerId === 'buffer-zones') {
      regulationKey = 'buffer';
    } else if (layerId === 'water') {
      regulationKey = 'water';
    } else {
      continue;
    }

    const rules = REGULATIONS[regulationKey] || [];
    for (const rule of rules) {
      matched.push({
        ...rule,
        overlapPercentage: overlap.overlapPercentage,
        overlapArea: overlap.overlapArea,
        sourceLayer: layerId,
      });
    }
  }

  // Sort by severity: high > medium > low
  const severityOrder = { high: 0, medium: 1, low: 2 };
  matched.sort((a, b) => severityOrder[a.severity] - severityOrder[b.severity]);

  return matched;
}

export function getOverlapSummary(overlaps) {
  const names = [];
  for (const o of overlaps) {
    if (o.layerId === 'natura2000') names.push('Natura 2000-gebied');
    if (o.layerId === 'buffer-zones') names.push('bufferzone watergang');
    if (o.layerId === 'water') names.push('watergang');
  }
  return names;
}
